import { DatePicker } from "@tellescope/ui";
import { TellescopeFormFieldBaseProps } from "../types";
import { cn, formatDate } from "@tellescope/utils";
import { useMemo } from "react";

export interface DateStringFieldProps extends TellescopeFormFieldBaseProps<"dateString"> {}

export const DateStringField = ({ title, value, onChange, className, error, onBlur }: DateStringFieldProps) => {
  const dateFromValue = useMemo(() => {
    if (!value) return undefined;
    const splits = value.split("-");
    const monthStr = splits[0];
    if (monthStr === undefined) return undefined;
    const month = parseInt(monthStr);
    const dateStr = splits[1];
    if (dateStr === undefined) return undefined;
    const date = parseInt(dateStr);
    const yearStr = splits[2];
    if (yearStr === undefined) return undefined;
    const year = parseInt(yearStr);
    return new Date(year, month - 1, date);
  }, [value]);

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <DatePicker
        value={dateFromValue}
        onChange={(date) => {
          onChange(date ? formatDate(date, "MM-DD-YYYY") : undefined);
        }}
        onBlur={onBlur}
        onClose={onBlur}
        className={cn(className, !!error && "border-destructive")}
        displayFormat="MM-DD-YYYY"
        placeholder={formatDate(new Date(), "MM-DD-YYYY")}
        label=""
      />
      {!!error && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
